import React from 'react';
import styled from '@emotion/styled';
import { List } from '@mui/material';

import SidebarNavSection from './SidebarNavSection';
import { NavRoute } from '../../routes';

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

type SidebarNavProps = {
  items: NavRoute[];
};

const SidebarNav: React.FC<SidebarNavProps> = ({ items }) => {
  return (
    <Wrapper>
      <List disablePadding>
        <Items>{items && <SidebarNavSection component="div" pages={items} />}</Items>
      </List>
    </Wrapper>
  );
};

export default SidebarNav;
